import React, { useEffect } from "react";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
  Button,
  Modal,
  MobileModal,
  Textarea,
} from "@my-scoot/component-library-legacy";

import { getAnswerText, getS3SignedUrl } from "utils/Utils";
import dataProvider from "data/dataProvider";
import { is_empty } from "utils/validations";
import api from "data/APIs";

import useStyles from "./bookingQuestions.styles";
import { useNotifications } from "utils/hooks";
import {
  BOOKING_QUESTIONS_MODAL_TXN_TYPE,
  KYC_QUESTION_TYPES,
} from "ui/pages/transactions/AllTransaction/transactions.constants";
import { question_type_id } from "constants/customerQuestions.constants";
import { KYCDetailsField } from "features/Transactions/modules/GSTDetailsField/KYCDetailsField";
import { getMaskedAadhaar } from "utils/aadhaar";
export const BookingQuestions = ({
  data,
  type,
  hideModal,
  title,
  isOpen,
  filterQuestionTypes = [],
  showQuestionLabelIndex = true,
}) => {
  const isDesktop = useDesktopMediaQuery();
  const classes = useStyles({ isDesktop });
  const { pushNotification } = useNotifications();
  const [apiData, setApiData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    if (!data) return;
    if (type === "lead") {
      let query_params;
      if (!is_empty(data.email)) {
        query_params.email = data.email;
      } else {
        query_params = {
          phone_number: data.phone_number,
          country_code: data.country_code.substring(1),
        };
      }

      dataProvider
        .custom_request(api.lead_answers, "GET", {
          ...query_params,
        })
        .then(
          (response) => response.status === 200 && setApiData(response.data)
        )
        .catch(() => {
          hideModal();
          pushNotification("An error occurred.", {
            variant: "outlined",
            color: "coral_red",
          });
          setApiData([]);
        })
        .finally(() => {
          setLoading(false);
        });
      return;
    }
    if (type === BOOKING_QUESTIONS_MODAL_TXN_TYPE.KYC) {
      setLoading(false);

      const formattedData = (data?.answer_list ?? []).map((q) => ({
        ...q,
        question_text: q.question,
        question_type: q.type,
      }));

      setApiData(
        filterQuestionTypes
          ? formattedData.filter((q) => filterQuestionTypes.includes(q.type))
          : formattedData
      );

      return;
    }
    dataProvider
      .custom_request(api.transaction_answers, "GET", {
        transaction_uid: data.transaction_uuid,
        username: data.username,
      })
      .then((response) => response.status === 200 && setApiData(response.data))
      .catch(() => {
        hideModal();
        pushNotification("An error occurred.", {
          variant: "outlined",
          color: "coral_red",
        });
        setApiData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [data]);

  const onDownloadFile = async (item) => {
    if (is_empty(item.text_answer)) return;
    const url = await getS3SignedUrl(item.text_answer);
    if (!is_empty(url)) window.open(url);
  };

  const content = (
    <div className={classes.bookingQuestionsWrapper}>
      {loading ? (
        <CircularProgress size={30} color="primary" />
      ) : (
        <div className="tw-flex tw-flex-col tw-gap-4 md:tw-min-w-[450px]">
          {apiData?.map((item, idx) => {
            if (item.question_type === question_type_id.FILE) {
              return (
                <div key={`${item}`}>
                  <div className={classes.qna_file_label}>{`${
                    showQuestionLabelIndex ? `Q${idx + 1}.` : ""
                  } ${item.question_text}`}</div>

                  <Button size="small" onClick={() => onDownloadFile(item)}>
                    View file
                  </Button>
                </div>
              );
            } else if (KYC_QUESTION_TYPES.includes(item.question_type)) {
              return (
                <div key={`${item}`}>
                  <div className={classes.qna_file_label}>{`${
                    showQuestionLabelIndex ? `Q${idx + 1}.` : ""
                  } ${item.question_text}`}</div>
                  <div className="tw-border-solid tw-border-gray-200 tw-py-2 tw-px-3 tw-rounded-lg">
                    <KYCDetailsField
                      answers={JSON.parse(item?.text_answer) ?? []}
                    />
                  </div>
                </div>
              );
            } else {
              return (
                <Textarea
                  key={`${item}`}
                  label={`Q${idx + 1}. ${item.question_text}`}
                  placeholder="N/A"
                  value={getAnswerText(item)}
                  size="small"
                  disabled={true}
                  fullWidth={true}
                  wrapperClassName={""}
                />
              );
            }
          })}
          {type === BOOKING_QUESTIONS_MODAL_TXN_TYPE.KYC &&
            !is_empty(data?.adhaar_number) && (
              <div className="tw-text-sm">
                <strong>Aadhaar Number</strong>:{" "}
                {getMaskedAadhaar(data?.adhaar_number)}
              </div>
            )}
        </div>
      )}
    </div>
  );

  return isDesktop ? (
    <Modal open={isOpen} title={title} onClose={hideModal} customFooter={<></>}>
      {content}
    </Modal>
  ) : (
    <MobileModal
      open={isOpen}
      onClose={hideModal}
      header={title}
      customFooter={<></>}
    >
      {content}
    </MobileModal>
  );
};
